export default "__VITE_ASSET__C9G9n24v__"